import { useCallback } from "react";

export const useExternalRedirect = () => {
  const handleExternalRedirect = useCallback((url: string) => {
    setTimeout(() => {
      window.location.href = url;
    }, 1000);
  }, []);

  return { handleExternalRedirect };
};